import { evolutionPathParam } from "@repo/shared/evolutions";
import { EvoPathId, type MetaRating } from "@repo/shared/types";

import axios from "../../api";

type Props = {
  resourceId: number;
  playerRoleId?: number;
  chemistry?: number;
  allChemStyles?: number;
  evolutionPath?: number[];
  pathwayPath?: number[][];
  evoPathId?: EvoPathId;
};

export const getMetaRatings = async ({
  resourceId,
  playerRoleId,
  chemistry,
  allChemStyles,
  evolutionPath,
  pathwayPath,
  evoPathId,
}: Props) => {
  const queryParams = new URLSearchParams();
  if (evolutionPath?.length)
    queryParams.append(
      "evolution-path",
      evolutionPathParam(evolutionPath, pathwayPath),
    );
  if (evoPathId) queryParams.append("evoPathId", "" + evoPathId);
  if (playerRoleId)
    queryParams.append("player-role-id", playerRoleId.toString());
  if (chemistry >= 0) queryParams.append("chemistry", chemistry.toString());
  queryParams.append("resourceId", resourceId?.toString());
  queryParams.append(
    "allChemStyles",
    allChemStyles ? allChemStyles.toString() : "0",
  );
  const url = `/squad-builder/meta-ratings?${queryParams.toString()}`;

  const res = await axios.get<MetaRating[]>(url);
  return res.data;
};
